import React from "react";
import ModalWindow from "../Shared/ModalWindow";

export default class CancelOrderModal extends React.Component {

    constructor (props) {

        super(props);
        this.state = {
            "commentEdit": ""
        };

    }

    handleOnChangeText (event) {

        this.setState({
            "commentEdit": event.target.value
        });

    }

    handleOnClickCancel () {

        this.setState({"commentEdit": ""});

    }


    render () {

        const comment = this.state.commentEdit,
            text = "Please Enter a reason as to why you wish to cancel the order",

            confirmBody =
                (<div className="text-left">
                 <p>
                    {text}
                </p>
                 <textarea
className="form-control"
                     value={comment}
                    placeholder="Add a Comment"
                    onChange={(e) => this.handleOnChangeText(e)}
                />
                 <button
className="btn modalButton"
                    data-dismiss="modal"
                    disabled={comment.length <= 0}
                     onClick={() => this.props.onClickSaveCancelOrderModal(comment)}
                >
Save
                 </button>
                 <button
className="btn modalButton"
                    data-dismiss="modal"
                     href={`#${  this.props.modalId}`}
                     onClick={() => this.handleOnClickCancel()}
                >
Cancel
                 </button>
             </div>);

        return (
            <ModalWindow
                modalBody={confirmBody}
                modalId={this.props.modalId}
                modalTitle={this.props.modalTitle}
                onModalClose={() => this.handleOnClickCancel()}
            />
        );

    }

}
